"use client";

import { CMSData } from "@/cms/models";
import { GetContentComponent } from "@/services/component.service";
import { ApplicationFraction } from "@/utils/gql/graphql";
import React, { useEffect, useState } from "react";

export interface AutoSliderComponentProps {
  cmsData: CMSData;
  app: ApplicationFraction;
  items: any[];
  config: {
    interval?: number;
  };
}

const AutoSliderComponent: React.FC<{
  config: AutoSliderComponentProps;
}> = ({ config }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % config.items.length);
    }, config.config.interval || 5000);
    return () => clearInterval(interval);
  }, [config.config.interval, config.items.length]);

  if (!config.items || config.items.length === 0) {
    return null;
  }

  return (
    <>
      {config.items.map((item, i) => {
        const content = GetContentComponent(
          config.cmsData,
          item,
          `grid-content-${i}`,
          index,
          config.app
        );

        return (
          <div
            key={i}
            className={`absolute top-0 left-0 w-full h-full bg-cover bg-center transition-opacity duration-1000 ease-in-out ${
              i === index ? "opacity-100 z-10" : "opacity-0 z-0"
            }`}
          >
            {content}
          </div>
        );
      })}
    </>
  );
};

export default AutoSliderComponent;
